<template>
  <div :class="['flex vcenter mb-10', titleTop ? 'title-top' : '', labelTop && 'labelTop']" :style="styleSet">
    <div
        class="item-title"
        :style="{
				'justify-content': labelAlign === 'left' && 'flex-start',
				width: labelWidth ? String(labelWidth) + 'px' : '',
				'min-width': labelWidth ? String(labelWidth) + 'px' : '',
			}"
    >
      <span v-if="required" class="item-red-star">*</span>
      <span style="position: relative">
				{{ label }}
			</span>
      <el-tooltip v-if="tip" effect="dark" :content="tip" placement="top">
        <el-icon class="fs-12 cursor ml-2">
          <QuestionFilled></QuestionFilled>
        </el-icon>
      </el-tooltip>
    </div>
    <div class="flex1">
      <div class="item-content" :style="contentStyle">
        <slot></slot>
      </div>
      <slot name="tail"></slot>
    </div>
  </div>
</template>

<script>

import {QuestionFilled} from "@element-plus/icons-vue";

export default {
  name: "form-item",
  components: {QuestionFilled},
  props: {
    tip: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    labelTop: {
      type: Boolean,
    },
    styleSet: {
      type: Object,
      default: function () {
        return {};
      },
    },
    contentStyle: {
      type: Object,
      default: function () {
        return {};
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
    titleTop: {
      type: Boolean,
      default: false,
    },
    labelWidth: {},
    labelAlign: {
      default: "right",
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.title-top {
  align-items: flex-start;
}

.dark {
  .item-title {
    color: $darkTextColor
  }
}

.item-title {
  padding-right: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  word-break: break-all;
  white-space: nowrap;
  font-size: 12px;
  color: $settingTextColor;
}

.item-title-wrap-l .item-title {
  width: 110px;
}

.item-title-wrap-l2 .item-title {
  width: 160px;
}

.item-title-wrap-l3 .item-title {
  width: 240px;
}

.item-red-star {
  font-size: 15px;
  color: #f00;
  margin-right: 2px;
}

.item-content {
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 8px;
}

.form-mw {
  .item-content {
    min-width: 220px;
  }
}

.labelTop {
  flex-direction: column;
  align-items: flex-start;

  .item-title {
    margin-bottom: 10px;
  }
}
</style>
